import { IC_PIN_GRAY, IC_PIN_PRIMARY } from '../../../../modules/images'

import { QIcon_caf_overview } from '@repo/icons/index'
import classNames from 'classnames'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import { COLORS } from '../../../../modules/vars'
import PinIcon from '../common/HighlightPinIcon'
import HighlightedTitle from '../common/HighlightedTitle'

export interface HighlightPinCardProps {
  isActive: boolean
  isSelected: boolean
  upperTitle: { text: string; icon: React.FC<React.SVGProps<SVGSVGElement>> }
  mainText: string
  onClick: (tag: number) => void
  tag: number
}

const HighlightPinCard = ({
  isSelected,
  isActive = true,
  upperTitle = { text: '', icon: (props) => <QIcon_caf_overview {...props} color={COLORS.PURPLE500} /> },
  mainText = '',
  onClick,
  tag,
}: HighlightPinCardProps) => {
  const isMobile = useIsMobile()
  if (isMobile) {
    return (
      <div className={styles.container(isSelected)} onClick={() => onClick(tag)}>
        <div className="flex justify-between">
          <div>
            <h5>{<LinkTitle content={upperTitle} />}</h5>
            <div className="mb-[4px] flex items-start justify-between">
              <h3 className="text-h5 text-black">{<HighlightedTitle title={mainText} color={COLORS.PURPLE50} />}</h3>
            </div>
          </div>
          <img src={isSelected ? IC_PIN_PRIMARY : IC_PIN_GRAY} className="h-[20px]" alt="pin mark" />
        </div>
      </div>
    )
  } else {
    return (
      <div className={styles.container_pc(isActive, isSelected)} onClick={() => onClick(tag)}>
        <div className="flex justify-between">
          <div>
            <h5>{<LinkTitle content={upperTitle} isActive={isActive} />}</h5>
            <div className="mb-[4px] flex items-start justify-between">
              <h3
                className={classNames('text-h5', {
                  'text-black': isActive,
                  'text-gray-500': !isActive,
                })}
              >
                {
                  <HighlightedTitle
                    disabled={!isActive}
                    title={mainText}
                    color={isActive ? COLORS.PURPLE50 : COLORS.GRAY50}
                  />
                }
              </h3>
            </div>
          </div>
          {/* <img src={isSelected ? IC_PIN_PRIMARY : IC_PIN_GRAY} className="h-[20px]" alt="pin mark" /> */}
          <PinIcon tag={tag} isActive={isSelected} width={24} height={24} tooltipDisabled={true} />
        </div>
      </div>
    )
  }
}

const LinkTitle = ({
  content,
  isActive = false,
}: {
  content: { text: string; icon: React.FC<React.SVGProps<SVGSVGElement>> }
  isActive?: boolean
}) => {
  const isMobile = useIsMobile()
  if (isMobile) {
    return (
      <div className="mb-4 flex items-center">
        <content.icon width={18} height={18} className="mr-[2px]" color={COLORS.PURPLE500} />
        <span
          className={classNames('text-h5 h-[18px] font-medium', {
            'text-purple-500': isActive,
            'text-gray-500': !isActive,
          })}
        >
          {content.text}
        </span>
      </div>
    )
  } else {
    return (
      <div
        className={classNames('mb-4 flex items-center', {
          'color-purple-500': isActive,
          'text-gray-500': !isActive,
        })}
      >
        <content.icon
          width={18}
          height={18}
          className="mr-[2px] [&>*]:fill-current"
          color={isActive ? COLORS.PURPLE500 : COLORS.GRAY500}
          fill={isActive ? COLORS.PURPLE500 : COLORS.GRAY500}
        />
        <span
          className={classNames('text-h5 h-[18px] font-medium', {
            'text-purple-500': isActive,
            'text-gray-500': !isActive,
          })}
        >
          {content.text}
        </span>
      </div>
    )
  }
}

export default HighlightPinCard

const styles = {
  container: (selected: boolean) =>
    classNames(`mb-[8px] rounded-[6px] border p-[16px] shadow-sm `, selected ? `border-purple-500` : `border-gray-100`),
  container_pc: (active: boolean, isSelected: boolean) =>
    classNames(
      `mb-[8px] w-[100%] cursor-pointer rounded-[6px] p-[16px] shadow-sm`,
      active ? (isSelected ? `bg-purple-50` : `bg-white`) : `bg-gray-100`,
      isSelected ? `border border-purple-500` : active ? `border border-gray-200` : `border border-gray-200`
    ),
}
